import { component } from 'picoapp';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default component((node: HTMLElement) => {
  gsap.to(node, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: 'Power2.easeOut',
  });
});
